export function filterDuplicates<T>(array: T[], uniqueKey: keyof T): T[] {
    const seen = new Set()
    return array.filter((item) => {
        const key = item[uniqueKey]
        if (seen.has(key)) {
            return false
        }
        seen.add(key)
        return true
    })
}
